import { Component, OnInit, ViewChild } from '@angular/core';
import { CrudService } from '../../services/crud/crud.service';
import { environment } from '../../../environments/environment';
import { AccionesModule } from './acciones.module';
import { AccionModel } from '../../services/sso/models/menu.accion.model';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';
import { jqxLoaderComponent } from 'jqwidgets-ng/jqxloader';
import { jqxInputComponent } from 'jqwidgets-ng/jqxinput';
import {
  Validators,
  UntypedFormBuilder,
  UntypedFormGroup,
  FormBuilder,
} from '@angular/forms';
import { MainComponent } from '../main/main.component';
import { MenuService } from '../../services/menu/menu.service';

@Component({
  selector: 'app-acciones',
  templateUrl: './acciones.component.html',
  styleUrls: ['./acciones.component.css'],
})
export class AccionesComponent implements OnInit {
  @ViewChild('jqxLoader') jqxLoader: jqxLoaderComponent;
  @ViewChild('myGrid') myGrid: jqxGridComponent;
  @ViewChild('mySearch') mySearch: jqxInputComponent;
  @ViewChild('myWindow') myWindow: jqxWindowComponent;
  @ViewChild('eventWindow') eventWindow: jqxWindowComponent;

  public environment = environment;
  private componentRef = null;

  dataSource;
  dataAdapter;
  editrow = -1;

  acciones: AccionModel[] = [];
  accion: AccionModel = new AccionModel();

  disabledId = false;
  // Formulario para crear o modificar rol
  miFormulario: UntypedFormGroup = this.fb.group({
    Id: ['', [Validators.required]],
    Observaciones: ['', [Validators.required]],
  });

  constructor(
    private menuService: MenuService,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.getAcciones();
  }

  // Este método es llamado por el creador del componente
  public init(componentRef: any) {
    this.componentRef = componentRef;
  }

  //MENU-------------------------------------------------------------------
  // Pongo por defecto los textos en los controles del grid en español
  public langGrid = JqWidgets.getLocalization('es');

  columns = [
    {
      text: '',
      width: 80,
      columntype: 'text',
      sortable: false,
      editable: false,
      datafield: 'Botones',
      rendered: (columnHeaderElement) => {
        const buttonContainer1 = document.createElement('div');

        const options = {
          width: '100%',
          value: '<i class="fa fa-plus-circle fa-lg" aria-hidden="true"></i>',
          textImageRelation: 'imageAboveText',
        };
        buttonContainer1.id = `buttonContainerColumn_jqxButton`;

        columnHeaderElement[0].appendChild(buttonContainer1);

        setTimeout(() => {
          let myButton = jqwidgets.createInstance(
            `#buttonContainerColumn_jqxButton`,
            'jqxButton',
            options,
          );
          buttonContainer1.parentElement.style.display = 'flex';
          myButton.addEventHandler('click', () => {
            this.myWindow.open();
          });
        }, 50);
        return columnHeaderElement[0];
      },
      createwidget: (
        row: any,
        column: any,
        value: string,
        htmlElement: HTMLElement,
      ): void => {
        this.initBtnColumn(row, column, value, htmlElement);
      },
      initwidget: (
        row: any,
        column: any,
        value: string,
        htmlElement: HTMLElement,
      ) => {
        this.initBtnColumn(row, column, value, htmlElement);
      },
    },
    {
      text: 'ID',
      datafield: 'Id',
      width: '30%',
      cellsalign: 'left',
      align: 'left',
    },
    { text: 'Observaciones', datafield: 'Observaciones' },
  ];

  // Obtiene los roles e inicia el adaptador
  async getAcciones() {
    this.acciones = await this.menuService.getActions();
    if (this.acciones) {
      this.dataSource = {
        datatype: 'json',
        datafields: [
          { name: 'Botones', type: 'string', map: 'Id' },
          { name: 'Id', type: 'string', map: 'Id' },
          { name: 'Observaciones', type: 'string', map: 'Observaciones' },
        ],
        localdata: this.acciones,
      };
      this.dataAdapter = new jqx.dataAdapter(this.dataSource);
    }
    this.jqxLoader.close();
  }

  // Incializa la columna de iconos
  initBtnColumn(
    row: any,
    column: any,
    value: string,
    htmlElement: HTMLElement,
  ) {
    this.jqxLoader.open();
    htmlElement.innerHTML = '';

    // Creo un contenedor para los botones
    const btnContainer = document.createElement('div');

    // Creo los botones
    const btnDel = document.createElement('div');
    btnDel.innerHTML =
      '<button class="jqx-rc-all jqx-button jqx-widget jqx-fill-state-normal" style="float: left; margin-left: 1px; margin-top: 2px; height: 30px; width: 39px;">' +
      '<i class="fa fa-trash fa-lg" aria-hidden="true"></i></button>';
    const btnEdit = document.createElement('div');
    btnEdit.innerHTML =
      '<button class="jqx-rc-all jqx-button jqx-widget jqx-fill-state-normal" style="float: left; margin-left: 1px; margin-top: 2px; height: 30px; width: 39px;">' +
      '<i class="fa fa-edit fa-lg" aria-hidden="true"></i></button>';

    // Añado los botones al contenedor
    btnContainer.appendChild(btnDel);
    btnContainer.appendChild(btnEdit);

    // Añado el contenedor a la columna
    htmlElement.appendChild(btnContainer);

    // Capturo el click de los botones
    btnDel.addEventListener('click', (event: any) => {});

    btnEdit.addEventListener('click', (event: any) => {
      if (row.boundindex) {
        this.editrow = row.boundindex;
      } else {
        this.editrow = row;
      }

      //busco en el array de columnas el que coincida con el id
      //Si value es undefined se busca el id con el metodo del grid
      let data = this.myGrid.getrowdata(this.editrow);
      if (data) {
        let found = this.acciones.find((accion) => accion.Id === data.Id);
        this.accion = found;
      } else {
        this.accion = this.acciones[0];
      }

      this.updateValues(this.accion); //Le paso los datos al formulario
      // show the popup window.
      this.myWindow.open();
    });
    this.jqxLoader.close();
  }

  //FORM--------------------------------------------------------------------------------------
  campoEsValido(campo: string) {
    return this.miFormulario.controls[campo].errors;
  }

  inputInval(campo: string) {
    return this.miFormulario.controls[campo].invalid;
  }

  showForm(): void {
    // show the popup window.
    this.myWindow.open();
  }

  // Actualiza el formulario
  updateValues(data: any) {
    this.disabledId = true; //Deshabilita la edición en el input de ID
    this.miFormulario.setValue({
      Id: data.Id,
      Observaciones: data.Observaciones,
    });
  }

  // Borra el rol
  deleteBtn(): void {}

  // Guarda la accion nueva o edita si ya existe
  async saveBtn() {
    this.jqxLoader.open();
    let dataForm = this.miFormulario.value;
    let rowID = this.myGrid.getrowid(this.editrow);

    if (this.editrow >= 0) {
      //Si no viene de la tabla se crea uno nuevo
      this.accion = await this.menuService.addEditActions(dataForm);
      this.acciones[rowID] = this.accion;
      this.myGrid.updaterow(rowID, this.accion);
      MainComponent.getInstance().showSuccess(
        'ATENCION',
        'Registro actualizado',
        2000,
      );
    } else {
      this.accion = await this.menuService.addEditActions(dataForm);
      this.acciones.push(this.accion);
      this.myGrid.addrow(null, this.accion);
      MainComponent.getInstance().showSuccess(
        'ATENCION',
        'Registro creado',
        2000,
      );
    }

    this.myWindow.close();
    this.clearData();
    this.jqxLoader.close();
  }

  // Limpia data y cierra la ventana
  cancelBtn(): void {
    this.myWindow.close();
    this.clearData();
  }

  // Limpia el form y resetea
  clearData(): void {
    this.disabledId = false;
    setTimeout(() => {
      this.miFormulario.reset();
      this.editrow = -1;
    }, 500);
  }

  //FILTROS-----------------------------------------------------------------------------
  // Busca en todos los campos de la tabla
  findSearch(): void {
    let searchText = this.mySearch.val();

    let filtergroup = new jqx.filter();
    filtergroup.operator = 'or';
    let filter_or_operator = 1;

    let filtervalue = searchText;
    let filtercondition = 'contains';
    let filter = filtergroup.createfilter(
      'stringfilter',
      filtervalue,
      filtercondition,
    );

    //Busca en todas las columnas y los añade al filtro
    for (let columna of this.columns) {
      let datafield = columna.datafield;

      filtergroup.addfilter(filter_or_operator, filter);
      this.myGrid.addfilter(datafield, filtergroup);
    }
    // apply the filters.
    this.myGrid.applyfilters();
  }

  clearFilters() {
    this.myGrid.clearfilters();
    this.mySearch.val('');
  }
}
